<template>
    <div class="body"
        :style="{backgroundImage: 'url(' + activityPictureUrl + ')'}">
        <!-- 获奖轮播 -->
        <div @click="goWinnerList">
            <vue-seamless-scroll v-if="activityStatus === '3'"
                :data="newWinnerList"
                :class-option="classOptionUp"
                class="marquee-up">
                <ul>
                    <li v-for="(item, index) in newWinnerList"
                        :key="index"
                        class="carousel">
                        <div class="more more-first">
                            <div class="auto-text">恭喜</div>
                            <div class="name-text name-text-first"
                                :style="{color:activityConfig.buttonColor}">{{item.nickName.anonymizedText}}</div>
                        </div>
                        <div class="more more-two">
                            <div class="auto-text">获得</div>
                            <div class="name-text name-text-two"
                                :style="{color:activityConfig.buttonColor}">{{item.rewardName}}</div>
                        </div>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>
        <div v-if="stepShow"
            class="step1">
            <img class="box-img"
                :style="{'margin':activityStatus === '1' ? '25.8vh auto 0' : '21.1vh auto 0'}"
                :src="drawWheelUrl">
            <!-- 有积分抽奖 -->
            <div v-if="drawType === 'pointDraw' && activityStatus === '1'"
                class="integral">
                <div>{{drawPointConsumption}}积分/次</div>
                <div>您剩余积分：{{balancePonits}}</div>
            </div>
            <div v-if="(drawType === 'initDraw' || drawType === 'orderDraw') && activityStatus === '1' "
                class="step-times">
                <div v-if="tips">{{ tips }}</div>
                <div v-else>剩余抽奖次数{{ participateTimes }}次</div>
            </div>
            <div v-if="pointDrawFlag && loginType == 'Alipay'"
                class="button"
                :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor,'box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}`}">
                <div class="login-p">登录荣耀会员获得抽奖机会</div>
                <div class="go-login"
                    @click="goHiHonorMiniProgram('index')"></div>
            </div>
            <div v-else
                :class="activityStatus === '1' ? 'button' : 'button button-mt'"
                :style="{'background':activityStatus === '1' ? activityConfig.buttonColor : '#E0E0E0','color':activityStatus === '1' ? activityConfig.buttonTextColor : '#ffffff','box-shadow': activityStatus === '1' ? `0px 0px 8px 0px ${activityConfig.buttonColor}` : '0px 0px 8px 0px #E0E0E0'}"
                @click="showPopupEndPage">
                {{ activityStatus === '1' ? '拆盲盒' : '活动已结束' }}
            </div>
        </div>
        <div v-else
            class="step2">
            <div ref="itemList"
                class="list"
                :style="{'margin-top':activityStatus === '1' ? '28vh' : '23.3vh','height':'48vw','overflow-x':activityStatus === '3' ? 'hidden' : 'scroll'}"
                :class="{'d-f':['1'].includes(participateType)}">
                <div class="transparent"></div>
                <!-- 待开奖 -->
                <div class="list-item"
                    :style="{'justify-content':!['1'].includes(participateType)?'space-between':'center'}">
                    <div v-if="!['1'].includes(participateType)"
                        class="circle-inherit"
                        :style="{'opacity':!['1'].includes(participateType)?0:1}">
                        <div v-for="(it,index) in 2"
                            :key="index + 1"
                            :style="{'background-color':newBlindBoxData.activityConfig.slidePointColor}"
                            class="small-circle small-circle-op">
                        </div>
                    </div>
                    <div class="circle circle-op"
                        :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor + '25','box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}` }">
                        {{ activityStatus === '1' ? '待开奖' : '活动已结束'}}
                    </div>
                    <div v-if="!['1'].includes(participateType)"
                        class="circle-inherit">
                        <div v-for="(it,index) in 2"
                            :key="index + 3"
                            :style="{'background-color':newBlindBoxData.activityConfig.slidePointColor}"
                            class="small-circle">
                        </div>
                    </div>
                </div>
                <!-- 助力 -->
                <div class="list-item"
                    v-if="!['1','1,6'].includes(participateType)">
                    <div class="circle-inherit">
                        <div v-for="(it,index) in 2"
                            :key="index + 1"
                            :style="{'background-color':newBlindBoxData.activityConfig.slidePointColor}"
                            class="small-circle">
                        </div>
                    </div>
                    <div class="circle"
                        :style="{'background':activityConfig.buttonColor,'color':helpFlag || activityStatus === '3'?activityConfig.buttonTextColor + '25':activityConfig.buttonTextColor,'box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}` }"
                        @click="clickToHelp">
                        {{ helpText }}
                    </div>
                    <div :class="participateType === '1,7' ? 'circle-opacity circle-inherit' : 'circle-inherit'">
                        <div v-for="(it,index) in 2"
                            :key="index + 3"
                            :style="{'background-color':newBlindBoxData.activityConfig.slidePointColor}"
                            class="small-circle">
                        </div>
                    </div>
                </div>
                <!-- 分享好友 -->
                <div class="list-item"
                    v-if="!['1','1,7'].includes(participateType)">
                    <div class="circle-inherit">
                        <div v-for="(it,index) in 2"
                            :key="index + 1"
                            :style="{'background-color':newBlindBoxData.activityConfig.slidePointColor}"
                            class="small-circle">
                        </div>
                    </div>
                    <div class="circle"
                        :style="{'background':activityConfig.buttonColor,'color':(remainingSharingTimes>0 && activityStatus === '1')?activityConfig.buttonTextColor:activityConfig.buttonTextColor + '25','box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}` }"
                        @click="clickToShare">
                        <div class="circle-share">
                            <span>分享好友</span>
                            <span style="font-size:18px">剩余{{ remainingSharingTimes }}次</span>
                        </div>
                    </div>
                    <div class="circle-inherit">
                        <div v-for="(it,index) in 2"
                            :key="index + 3"
                            :style="{'background-color':newBlindBoxData.activityConfig.slidePointColor}"
                            class="small-circle small-circle-op ">
                        </div>
                    </div>
                </div>
                <div class="transparent"></div>
            </div>
            <!-- 中奖率 -->
            <div v-if="oddWinningShow && activityStatus === '1'"
                class="odd-winning"
                :style="{opacity: Number(winningRate) ? 1 : 0}">
                中奖率<span class="odd-winning-text"
                    :style="{color:activityConfig.buttonColor}">+{{Number(winningRate)}}</span><span
                    v-if="showExceedPercentParticipant">，已超过{{Number(userPercent) > 99 ? 99 : Number(userPercent) }}%的参与者</span>
            </div>
            <!-- 参与人数头像集合 -->
            <div class="participate"
                :style="{'margin-top' : oddWinningShow ? '3.9vh' : '9.6vh'}">
                已有<span>{{userNum}}</span>人参与
            </div>
            <div class="avatar-list"
                :style="{ 'justify-content' : userMessageList.length > 4 ? 'space-between' : 'center'}">
                <div v-for="(item,index) in userMessageList"
                    :key="index"
                    class="avatar">
                    <div class="avatar-out">
                        <img class="avatar-img"
                            :src="item.userHeadPortraitUrl">
                    </div>
                    <span class="avatar-text">{{item.anonymizedText}}</span>
                </div>
            </div>
        </div>
        <div v-if="miniprogramFlag || loginType == 'Alipay'"
            class="winning-inquiry"
            @click="winningInquiry">
            中奖查询
        </div>
        <div v-if="!miniprogramFlag && loginType == 'wechat'"
            class="winning-inquiry">
            中奖查询
            <div class="content-winningPrize-buttom-wechat">
                <!-- 体验店 -->
                <div class="wxOpenLaunchWeapp"
                    v-html="wxOpenLaunchWeappHiHonor"></div>
            </div>
        </div>
        <div class="click"
            @click="clickToLook">
            <div class="triangle">&#9650;</div>
            点击查看活动奖品和规则
        </div>
        <!-- 活动奖品和规则 -->
        <van-popup v-model="showGift"
            position="bottom"
            round
            :style="{ height: '74.1%' }">
            <div class="content">
                <div class="click-to-back"
                    @click="clickToBack">
                    回到拆盲盒页面
                    <div class="triangle">&#9660;</div>
                </div>
                <div class="prize-pool-content">
                    <span class="prize-pool">奖品池</span>
                    <vue-seamless-scroll v-if="prizeList.length > 4"
                        :data="prizeList"
                        :class-option="classOption"
                        class="warp"
                        :style="{width:100 * prizeList.length * 2 + 'px'}">
                        <ul class="ul-item"
                            :style="{width:100 * prizeList.length + 'px'}">
                            <li v-for="(item, index) in prizeList"
                                :key="index"
                                class="li-item">
                                <img class="prize-img"
                                    :src="item.imgUrl">
                                <div class="li-item-text">{{ item.goodsName }}</div>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                    <div v-else>
                        <ul class="ul-itm"
                            :style="{'justify-content': prizeList.length < 4 ? 'space-around' : 'space-between' }">
                            <li v-for="(item, index) in prizeList"
                                :key="index"
                                class="li-itm">
                                <img class="li-img"
                                    :src="item.imgUrl">
                                <div class="li-item-text">{{ item.goodsName }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="activity-rules-content">
                    <span class="activity-rules">活动规则</span>
                    <div class="activity-rules-content-bottom"
                        v-html="ruleDesci"></div>
                </div>
            </div>
        </van-popup>
        <!-- 助力  -->
        <van-popup v-model="showHelp"
            position="bottom"
            :lazy-render="false"
            round
            closeable
            :style="{ 'max-height': '74.1%' }">
            <img class="help-img"
                :src="helpingPosterUrl">
            <div class="click-to-help"
                :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor,'box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}` }"
                @click="clickHelp">
                <div>点我</div>
                <div>助力</div>
            </div>
        </van-popup>
        <transition name="van-fade">
            <end-page v-if="showEndPage"
                :tips="tips"
                :newBlindBoxData="newBlindBoxData"
                :endType="regularDrawShowStatus"
                :myRecord="myRecord"
                :drawPointConsumption="drawPointConsumption"
                :balancePonits="balancePonits"
                :userLotteryNum="userLotteryNum"
                :userNum="userNum"
                :drawType="drawType"
                :participateTimes="participateTimes"
                :showExceedPercentParticipant="showExceedPercentParticipant"
                :userPercent="userPercent"
                :newWinningRate="newWinningRate"
                :winningRate="winningRate"
                :remainingSharingTimes="remainingSharingTimes"
                :activityStatus="activityStatus"
                :miniprogramFlag="miniprogramFlag"
                :userWinNum="userWinNum"
                :activityUrl="activityUrl"
                :helpFlag="helpFlag"
                @closeEnd="closeEnd"
                @showPopupEndPage="showPopupEndPage"
                @goWinnerList="goWinnerList"
                @winningInquiry="winningInquiry"
                @clickToShare="clickToShare"
                @nextStep="nextStep"></end-page>
        </transition>
    </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import endPage from './endPage.vue';
import wx from 'weixin-js-sdk';
import { Dialog, Toast, NoticeBar, Swipe, SwipeItem } from 'vant';
import { config as configEnv} from '../../../../commons/config.js';
import { config } from '@/api/config.js';
export default {
  components: {
    vueSeamlessScroll,
    endPage
  },
  props: {
    // 详细信息
    newBlindBoxData: {
      type: Object,
      default: {}
    },
    // 结果页状态
    // regularDrawShowStatus 1.活动结束后,用户有中奖;2.活动结束后,用户未中奖;3.活动已结束,但是用户未参与过活动;
    // 4.活动进行中,用户无次数;5.活动进行中,用户有次数;6.活动已结束,但是活动中奖逻辑还在计算中(开奖中)
    regularDrawShowStatus: {
      type: String,
      default: 0
    },
    // 结束页是否显示
    showEndPage: {
      type: Boolean,
      default: false
    },
    // 我的中奖记录
    myRecord: {
      type: Array,
      default: []
    },
    // 初始抽奖还是积分抽奖
    // initDraw： 初始抽奖  pointDraw：积分抽奖
    drawType: {
      type: String,
      default: ''
    },
    // 活动状态 0：未开始，1：进心中，2：暂停，3已结束（此处只存在1,3）
    activityStatus: {
      type: String,
      default: '0'
    },
    // 每次抽奖需要积分数
    drawPointConsumption: {
      type: Number,
      default: 10
    },
    // 剩余积分
    balancePonits: {
      type: String,
      default: ''
    },
    // 已抽奖次数
    userLotteryNum: {
      type: Number,
      default: 1
    },
    // 还可抽奖次数
    participateTimes: {
      type: Number,
      default: 0
    },
    // 超过用户数，和中奖用户数，共用同一个字段
    userNum: {
      type: Number,
      default: 1
    },
    userWinNum: {
      type: Number,
      default: 0
    },
    newWinnerList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    userBase: {
      type: Object,
      default: ''
    },
    miniprogramFlag: {
      type: Boolean,
      default: false
    },
    pointDrawFlag: {
      type: Boolean,
      default: false
    },
    activityUrl: {
      type: String,
      default: ''
    },
    newWinningRate: {
      type: Number,
      default: 0
    },
    isLoginFlag: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showGift: false,
      showHelp: false,
      oddWinningShow: true,
      stepShow: true,
      prizeList: [],
      classOption: {
        limitMoveNum: 5,
        direction: 2,
        step: 0.5
      },
      classOptionUp: {
        limitMoveNum: 2,
        direction: 1,
        step: 0.3
      },
      helpText: '点我助力',
      activityConfig: {},
      activityPictureUrl: '', // 背景图
      drawWheelUrl: '', // 未开奖图片
      ruleDesci: '', // 规则
      participateType: -1,
      userMessageList: [],
      helpingPosterUrl: '', //助力图片
      helpFlag: false, //是否参与过助力
      remainingSharingTimes: 0, //剩余分享次数
      winningRate: 0, //中奖率
      userPercent: 0, //参与者
      loginType: '',
      showExceedPercentParticipant: false,
      shareEveryDayLimit: 0,
      wxOpenLaunchWeappHiHonor: '',
      env: configEnv.env === 'pro' ? 'release' : 'trial',
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  watch: {
    newBlindBoxData: {
      handler(newValue) {
        this.userPercent = newValue.userPercent;
      },
      deep: true
    }
  },
  mounted() {
    this.loginType = sessionStorage.getItem('loginType') || '';
    window.scrollTo(100, 500);
    window.onscroll = function() {
      let t = document.documentElement.scrollTop || document.body.scrollTop;
    };
    this.init();
  },
  methods: {
    init() {
      this.activityConfig = this.newBlindBoxData.activityConfig;
      if (this.newBlindBoxData.activityPictureUrl) {
        this.activityPictureUrl = this.$utils.getImageUrl(JSON.parse(this.newBlindBoxData.activityPictureUrl).file);
      }
      if (this.newBlindBoxData.drawWheelUrl) {
        this.drawWheelUrl = this.$utils.getImageUrl(JSON.parse(this.newBlindBoxData.drawWheelUrl).file);
      }
      if (this.newBlindBoxData.helpingPosterUrl) {
        this.helpingPosterUrl = this.$utils.getImageUrl(JSON.parse(this.newBlindBoxData.helpingPosterUrl).file);
      }
      this.showExceedPercentParticipant = this.activityConfig.showExceedPercentParticipant;
      this.helpFlag = this.newBlindBoxData.helpFlag;
      this.remainingSharingTimes = this.newBlindBoxData.remainingSharingTimes;
      this.participateType = this.activityConfig.participateType;
      if (this.helpFlag) {
        this.helpText = '已完成助力';
      }
      this.winningRate = this.newBlindBoxData.winningRate;
      this.userPercent = this.newBlindBoxData.userPercent;
      this.newBlindBoxData.bigWheelRewardList.forEach(data => {
        const item = {
          imgUrl: data.imgUrl,
          goodsName: data.goodsName
        };
        if (data.goodsType !== '0') {
          this.prizeList.push(item);
        }
      });
      this.classOption.limitMoveNum = this.prizeList.length;
      this.ruleDesci = this.activityConfig.ruleDescri;
      if (this.ruleDesci.indexOf('<a href=') != -1) {
        this.ruleDesci = this.ruleDesci.replace(/<a [^>]*href=['"]([^'"]+)[^>]*>/g, function(match, capture) {
          const result = capture;
          return '<a href=' + result + ' rel="noopener noreferrer" target="_blank">';
        });
      }
      this.ruleDesci
        .replace(/↵/g, '<br/>')
        .replace(/\n/g, '<br/>')
        .replace(/ihlp/g, 'hd');
      if (!this.miniprogramFlag) {
        this.wxOpenLaunchWeappHiHonor = `<wx-open-launch-weapp id="launch-btn" env-version="${this.env}" username="${this.hiHonorWxAppId}" path="subpackages/my/pages/rewardQuery/reward-query"><template><style>.btn { width: 1000px;height: 300px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
      }
    },
    clickToLook() {
      this.showGift = true;
    },
    clickToBack() {
      this.showGift = false;
    },
    clickToHelp() {
      if (!this.helpFlag) {
        if (this.activityStatus === '3') {
          Toast('活动已结束,感谢您的支持！');
          return;
        }
        this.showHelp = true;
      } else {
        return;
      }
    },
    // 点击分享
    clickToShare() {
      if (this.activityStatus === '3') {
        Toast('活动已结束,感谢您的支持！');
        return;
      }
      if (this.remainingSharingTimes === 0) {
        Toast('您已达到本次抽奖活动的分享次数上限,感谢您的支持！');
        return;
      }
      this.$emit('openGuide');
      if (!this.miniprogramFlag && this.loginType == 'wechat') {
        const params = {
          sharesOpenId: this.userBase.unionid || '',
          activityId: this.newBlindBoxData.id,
          memberId: this.userBase.memberCenterId
        };
        this.$api.post({
          url: '/h5/sharesRecord/insert',
          noLoading: true,
          sc: 'mobileMarketing',
          params: params,
          success: r => {
            if (r.code === 200 && r.result) {
              setTimeout(() => {
                this.remainingSharingTimes = r.result.remainingSharingTimes;
                this.winningRate = r.result.winningRate;
                this.userPercent = r.result.userPercent;
              }, 3000);
            }
          }
        });
      }
    },
    // 点击助力
    clickHelp() {
      const params = {
        activityId: this.newBlindBoxData.id,
        userOpenid: this.loginType == 'wechat' ? this.userBase.openId || '' : '',
        userUnionid: this.loginType == 'wechat' ? this.userBase.unionid || '' : '',
        alipayUserId: this.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
        memberCenterId: this.userBase.memberCenterId
      };
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'h5/helpingRecord/insert',
        params: params,
        success: r => {
          if (r.code === 200 && r.result) {
            this.winningRate = r.result.winningRate;
            this.userPercent = r.result.userPercent;
            this.helpText = '已完成助力';
            this.showHelp = false;
            this.helpFlag = true;
            if (this.activityConfig.helpingRedirectConfig === '1') {
              const data = {
                helpingRedirectConfig: this.activityConfig.helpingRedirectConfig,
                helpingRedirectMode: this.activityConfig.helpingRedirectMode,
                helpingRedirectType: this.activityConfig.helpingRedirectType,
                helpingRedirectConfigContent: this.activityConfig.helpingRedirectConfigContent
              };
              this.$emit('goSkipPage', data);
            }
          }
        }
      });
    },
    // 展示结果页,抽奖
    showPopupEndPage() {
      if (this.activityObj.activityConfig.memberJoinLimit === '1' && this.activityObj.memberJoinStatus === 2) {
        // 入会时间限制开关(0关闭, 1开启)
        // 判断是否满足
        // 会员入会状态(-2: 未登录, -1: 活动未限制入会时间, 0: 当前用户未入会, 1: 满足条件(赠送抽奖机会), 2: 不满足条件(不赠送抽奖机会))"
        // 判断后台配置是否配置了跳转到其他页面
        let message = '';
        let memberPagePath = '';
        let confirmButtonText = '';
        if (this.activityObj.activityConfig.memberPagePathConfig === '1') {
          message = '您暂时不能参与此活动，去其他活动看看吧';
          memberPagePath = this.activityObj.activityConfig.memberPagePath;
          confirmButtonText = '去看看';
        } else {
          message = '您不是新用户，暂时无法参与该活动';
          confirmButtonText = '确定';
        }
        Dialog.alert({
          confirmButtonText: confirmButtonText,
          message: message,
          closeOnClickOverlay: true
        }).then(() => {
          if (memberPagePath) {
            this.nextStep(memberPagePath, '2');
          }
        });
        return;
      }
      if (this.activityStatus === '3') {
        Toast('活动已结束，感谢您的支持！');
        return;
      } else {
        if (['1,2', '2'].includes(this.participateType)) {
          if (this.drawType === 'initDraw') {
            this.$emit('pointer');
          } else {
            if (Number(this.balancePonits) < Number(this.drawPointConsumption)) {
              Toast('您的积分不足');
              return;
            } else {
              this.$emit('pointer');
            }
          }
        } else if (['1', '1,4', '4'].includes(this.participateType)) {
          if (this.drawType === 'initDraw') {
            this.$emit('pointer');
          } else {
            if (Number(this.participateTimes) === 0) {
              Toast('您的抽奖机会已用完');
              return;
            } else {
              this.$emit('pointer');
            }
          }
        } else {
          this.$emit('pointer');
        }
      }
    },
    // 关闭结果页
    closeEnd() {
      switch (this.participateType) {
        // 初始可抽奖
        case '1':
          this.$emit('closeEnd', false);
          this.stepShow = false;
          this.oddWinningShow = false;
          break;
        // 初始抽奖+积分抽奖
        case '1,2':
          this.stepShow = true;
          break;
        // 积分抽奖
        case '2':
          this.stepShow = true;
          break;
        // 初始抽奖+分享
        case '1,6':
          this.stepShow = false;
          this.$nextTick(() => {
            if (this.remainingSharingTimes !== 0) {
              const itemList = this.$refs.itemList;
              itemList.scrollTo(itemList.offsetWidth * 1, 0);
            }
          });
          break;
        // 初始抽奖+助力
        case '1,7':
          this.stepShow = false;
          this.$nextTick(() => {
            if (!this.helpFlag) {
              const itemList = this.$refs.itemList;
              itemList.scrollTo(itemList.offsetWidth * 1, 0);
            }
          });
          break;
        // 初始抽奖+助力+分享
        case '1,6,7':
          this.stepShow = false;
          this.$nextTick(() => {
            const itemList = this.$refs.itemList;
            if (!this.helpFlag) {
              itemList.scrollTo(itemList.offsetWidth * 0.66, 0);
            } else {
              if (this.remainingSharingTimes !== 0) {
                itemList.scrollTo(itemList.offsetWidth * 1, 0);
              } else {
                itemList.scrollTo(0, 0);
              }
            }
          });
          break;
        // 初始抽奖+订单
        case '1,4':
          this.stepShow = true;
          break;
        // 订单抽奖
        case '4':
          this.stepShow = true;
          break;
        default:
          break;
      }
      this.$emit('closeEnd', false);
      if (this.newBlindBoxData.bigwheelUserInfo && this.newBlindBoxData.bigwheelUserInfo.length) {
        this.userMessageList =
          this.newBlindBoxData.bigwheelUserInfo.map(res => {
            return {
              anonymizedText: res.nickName.anonymizedText.slice(0, 4) || '****',
              userHeadPortraitUrl: res.userHeadPortraitUrl
            };
          }) || [];
        this.userMessageList = this.userMessageList.slice(0, 5);
      }
    },
    winningInquiry() {
      this.$emit('goHiHonorMiniProgram', 'rewardQuery');
    },
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    goHiHonorMiniProgram(index) {
      this.$emit('goHiHonorMiniProgram', index);
    },
    nextStep(jumpUrl, jumpType) {
      this.$emit('nextStep', jumpUrl, jumpType);
    }
  }
};
</script>
<style scoped lang="scss">
.marquee-up {
  background-color: rgb(242, 247, 255);
  height: 4.7vh;
  width: 100vw;
  margin: 0 auto;
  overflow: hidden;
}
.body {
  height: 100vh;
  width: 100vw;
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.carousel {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  height: 4.7vh;
}
.auto-text {
  font-size: 14px;
  color: #181818;
  font-weight: 400;
  display: flex;
}
.name-text {
  font-size: 14px;
  font-weight: 400;
}
.name-text-first {
  width: 62px;
}
.name-text-two {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.title {
  text-align: center;
  margin-top: 5.1vh;
  font-size: 34.5px;
  line-height: 45px;
  color: #000000;
  font-weight: 600;
}
.honor-box {
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  margin-top: 0.8vh;
  font-family: HONORSansBrand-Regular;
}
.step1 {
  width: 100%;
}
.box-img {
  width: 61.3%;
  height: 39vh;
  display: block;
  animation: bounce-down 1.6s linear infinite;
}
.integral {
  margin-top: 3.3vh;
  font-size: 14px;
  color: #181818;
  text-align: center;
  font-weight: 400;
}
.step-times {
  font-size: 19px;
  font-weight: 500;
  text-align: center;
  margin-top: 3.3vh;
}
.more {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more-first {
  margin-left: 5%;
}
.more-two {
  flex: 1;
}
.button {
  position: relative;
  background-size: cover;
  width: 65%;
  font-size: 16px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  line-height: 47px;
  margin: 2.5vh auto 0;
  border-radius: 24px;
}
.button-mt {
  margin-top: 10.6vh;
}
.winning-inquiry {
  position: fixed;
  bottom: 9.9vh;
  font-size: 14px;
  color: #256fff;
  text-align: center;
  font-weight: 400;
  text-decoration: underline;
  .content-winningPrize-buttom-wechat {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}

.click {
  position: fixed;
  bottom: 1.4vh;
  font-size: 14px;
  color: #181818;
  text-align: center;
  font-weight: 400;
}
.help-img {
  width: 100vmin;
}
.click-to-help {
  height: 75px;
  width: 75px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 18px;
  font-weight: 500;
  margin: 8px auto;
}
.content {
  display: flex;
  text-align: center;
  padding: 15px;
  height: 100%;
  flex-direction: column;
  overflow-x: hidden;
}
.click-to-back {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
}
.prize-pool-content {
  margin-top: 10px;
}
.activity-rules-content {
  margin-top: 10px;
  height: 65%;
  overflow: hidden;
  .activity-rules-content-bottom {
    height: 80%;
    overflow: hidden;
    overflow-y: scroll;
    text-align: left;
  }
  .activity-rules-content-bottom /deep/ a {
    color: #2d8cf0 !important;
  }
  .activity-rules-content-bottom /deep/ pre {
    white-space:pre-wrap;
  }
}
.prize-pool {
  font-size: 16px;
  color: #256fff;
  text-align: center;
  font-weight: 600;
}
.activity-rules {
  font-size: 16px;
  color: #256fff;
  text-align: center;
  font-weight: 600;
}
.prize-img {
  height: 70px;
  width: 70px;
  margin: 15px;
}
.ul-item {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
}
.li-item-text {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ul-itm {
  display: flex;
  margin: 15px;
}
.li-itm {
  width: 23%;
}
.li-img {
  width: 15.733vw;
  height: 15.733vw;
}
.warp {
  margin: 0 auto;
  overflow: hidden;
}
.list {
  /* 设置固定宽度 */
  width: 100vw;
  overflow-x: scroll;
  display: -webkit-box;
  scroll-snap-type: x mandatory;
}
.d-f {
  display: flex;
}
.list-item {
  display: flex;
  width: 65%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  scroll-snap-align: center;
  scroll-snap-stop: always;
}
.circle {
  height: 45vw;
  width: 45vw;
  border-radius: 100%;
  background: #315dd2;
  text-align: center;
  font-size: 27px;
  color: #ffffff;
  font-weight: 500;
  line-height: 45vw;
  .circle-share {
    height: 45vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1;
    span:last-child {
      padding-top: 0.3vh;
    }
  }
}
.circle-op {
  color: #ffffff25;
}
.list::-webkit-scrollbar {
  /* 给父元素设置 隐藏滑动条 */
  display: none;
  width: 100px;
}

.small-circle {
  height: 7px;
  width: 7px;
  border-radius: 100%;
  margin-top: 1vh;
  margin-left: 4px;
  margin-right: 4px;
}
.small-circle-op {
  opacity: 0;
}
.transparent {
  width: 17.5%;
  height: 1px;
  display: block;
}
.odd-winning {
  font-size: 19px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
  margin-top: 2.5vh;
  line-height: 25px;
}
.odd-winning-text {
  color: #256fff;
}
.participate {
  font-size: 14px;
  color: #181818;
  text-align: center;
  font-weight: 400;
}
.avatar-list {
  display: flex;
  margin: 1.4vh auto 0;
  width: 74%;
}
.avatar {
  width: 13vw;
  text-align: center;
}
.avatar-out {
  position: relative;
  margin-left: 10%;
  width: 80%;
  height: 0;
  padding-top: 80%;
  border-radius: 50%;
  overflow: hidden;
}
.avatar-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.circle-inherit {
  display: inherit;
}
.circle-opacity {
  opacity: 0;
}
.login-p {
  position: relative;
}
.go-login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.avatar-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-align: center;
  margin-top: 1vh;
}
@keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }
  50%,
  100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(4px);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/timedDraw/index.vue